import ShButton from '@/components/Helpers/ShButton';

export default {
  name: 'NotificationsListItemConfiguration',

  components: {
    ShButton,
  },

  props: {
    notificationConfiguration: {
      type: Object,
      default: () => ({
        type: 'mail',
        recipient: '',
        isActive: false,
      }),
    },
  },

  data() {
    return {
      configuration: {},
      isTypeWasChanged: false,
      isRecipientWasChanged: false,

      validationRules: {
        recipient: [
          { required: true, message: 'Pole jest wymagane', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('Pole jest wymagane'));
            }

            // eslint-disable-next-line no-useless-escape
            if (this.configuration.type === 'sms' && value && (!(/^\d{9}$/).test(value))) callback(new Error('Nieprawidłowy numer telefonu'));
            if (
              this.configuration.type === 'mail'
              && value
              // eslint-disable-next-line no-useless-escape
              && (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value))
            ) callback(new Error('Nieprawidłowy adres email'));

            callback();
          },
          trigger: 'blur',
          },
        ],
      },
    };
  },

  created() {
    this.configuration = { ...this.notificationConfiguration };
  },

  watch: {
    notificationConfiguration() {
      this.configuration = { ...this.notificationConfiguration };
    },
  },

  computed: {
    isSubmitButtonVisible() {
      return (this.isTypeWasChanged || this.isRecipientWasChanged);
    },
  },

  methods: {
    handleToogleNotificationType() {
      this.isTypeWasChanged = true;
      this.configuration.recipient = '';
    },

    handleToogleNotificationRecipient(recipient) {
      if (recipient !== this.notificationConfiguration.recipient) this.isRecipientWasChanged = true;
      else this.isRecipientWasChanged = false;
    },

    handleChangeConfiguration() {
      this.$refs.form.validate((isValid) => {
        if (isValid) {
          this.isTypeWasChanged = false;
          this.isRecipientWasChanged = false;
          this.$emit('changeConfiguration', this.configuration);
        }
      });
    },

    handleCancelConfiguration() {
      this.$refs.form.resetFields();
      this.isTypeWasChanged = false;
      this.isRecipientWasChanged = false;
      this.configuration = { ...this.notificationConfiguration };
    },
  },
};
